(function () {
    'use strict';

    angular
        .module('app.reports')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'reports',
                  config: {
                      abstract: true,
                      url: '/reports',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1,
                          requireOps: true
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.userType() == "0") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'reports.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/reports/list.html?v=' + opsIncludeVersion,
                    controller: 'ReportsListController',
                    controllerAs: 'vm',
                    title: 'Reports',
                    settings: {
                        authMode: 1,
                        nav: 600,
                        content: '<i class="fa fa-file-text-o"></i> <span class="leftNavText">Reports</span>',
                        allowedUserTypes: [2, 1],
                        requireOps: true,
                        
                    }
                }
            }
            , {
                state: 'reports.notes',
                config: {
                    url: '/notes',
                    templateUrl: 'app/reports/notes/report.html?v=' + opsIncludeVersion,
                    controller: 'DailyNotesReportController',
                    controllerAs: 'vm',
                    title: 'Reports',
                    settings: {}

                }
            },
            {
                state: 'reports.analytics',
                config: {
                    url: '/analytics',
                    templateUrl: 'app/reports/analytics/report.html?v=' + opsIncludeVersion,
                    controller: 'CompletionsByRangeController',
                    controllerAs: 'vm',
                    title: 'Reports',
                    settings: {}

                }
            },
             {
                 state: 'reports.dailylogs',
                 config: {
                     url: '/dailylogs',
                     templateUrl: 'app/reports/dailyLogs/report.html?v=' + opsIncludeVersion,
                     controller: 'DailyLogsReportController',
                     controllerAs: 'vm',
                     title: 'Reports',
                     settings: {}
                 }
            },
             {
                 state: 'reports.eventcompletions',
                 config: {
                     url: '/eventcompletions',
                     templateUrl: 'app/reports/eventCompletions/report.html?v=' + opsIncludeVersion,
                     controller: 'EventCompletionsReportController',
                     controllerAs: 'vm',
                     title: 'Event Completions Report',
                     settings: {}
                 }
             }
        ];
    }
})();
